import React, { useState } from 'react';
import '../../css/shared/Upload.css';
import upload from '../../assets/images/upload_enable.svg';
import uploadDisable from '../../assets/images/upload_disable.svg';
import deleteDisable from '../../assets/images/delete_disable.svg';
import deleteEnable from '../../assets/images/delete_enable.svg';
import defaultImage from '../../assets/images/default_image.svg';
import { uploadApiCall } from '../../Services/utils/UploadApiCall';
import { utilityBaseURL } from '../../Services/config/apiGateway';
import { UPLOAD_ENDPOINT } from '../../Services/config/apiEndPoints';
import message from '../../data/Message.json'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
const Upload = (props) => {
    const [isUploadDisabled, setIsUploadDisabled] = useState(props.isUploadDisabled);
    const [isDeleteDisabled, setIsDeleteDisabled] = useState(props.isDeleteDisabled);
    const uploadDelete = props.uploadDelete
    function anchorClick(event) {
        event.preventDefault();
        document.querySelector('#' + props.idupload).click();
        let fileupload = document.getElementById(props.idupload);
        fileupload.onchange = function (e) {
            let files = e.target.files[0];
            if (fileupload.value.toLowerCase().match(/jpeg$/) || fileupload.value.toLowerCase().match(/jpg$/) || fileupload.value.toLowerCase().match(/png$/)) {
                if (fileupload.files.length > 0) {
                    for (let i = 0; i <= fileupload.files.length - 1; i++) {
                        const fsize = fileupload.files.item(i).size;
                        const file = Math.round((fsize / 1024));
                        if (file > 2048) {
                            toast("File too big, please select a file less than 2MB", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
                        }
                        else {
                            const newImage = new window.Image();
                            newImage.src = URL.createObjectURL(files);
                            newImage.onload = (el) => {
                                // image heigth width
                                console.log("width height", el);
                                console.log("only width", el.target.width)
                                console.log("only height", el.target.height)
                                const newName = e.target.files[0].name.replace(/[&\/\\#,+ ()$~%'":*?<>{}]/g, '');
                                if (el.target.width >= 1440 && el.target.height >= 500) {
                                    const reader = new window.FileReader();
                                    reader.readAsDataURL(files);
                                    reader.onload = (f) => {
                                        const formData1 = new window.FormData();
                                        formData1.append('file', files, newName);
                                        console.log("before api call", formData1);
                                        uploadApiCall(
                                            'POST',
                                            utilityBaseURL +
                                            UPLOAD_ENDPOINT,
                                            formData1,
                                            {
                                                Accept: 'application/json',
                                                ' x-cc-trace-id': '1234'
                                            },
                                            true,
                                            true
                                        ).then((response) => response)
                                            .then((data) => {
                                                console.log("img Data", data)
                                                if (data.flag !== -1) {
                                                    if (data.flag === 500) {
                                                        document.querySelector('#' + props.idupload).value = null;
                                                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                                                        console.log("in 500 data", data);
                                                    }
                                                    else {
                                                        console.log('I am 200!');
                                                        console.log("in 200 data", data);
                                                        setIsUploadDisabled(true);
                                                        setIsDeleteDisabled(false);
                                                        let image = document.getElementById(props.output);
                                                        image.src = URL.createObjectURL(fileupload.files[0]);
                                                        console.log("path", data.documentPath);
                                                        props.setImageLink(data.documentPath.replace(/\s/g, ''))
                                                        toast("File uploaded successfully", { position: toast.POSITION.TOP_CENTER, autoClose: 1000, style: { color: "black" } })
                                                    }
                                                } else {
                                                    document.querySelector('#' + props.idupload).value = null;
                                                    console.log("error")
                                                }
                                            });
                                    }
                                }
                                else {
                                    toast("Image cannot be uploaded as minimum dimensions are 1440 X 500 pixels.", { position: toast.POSITION.TOP_LEFT, autoClose: 5000, className: "toastMsg" });
                                }
                            }
                        }
                    }
                }
            }
            else { toast("File Should be jpeg, jpg and png.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } }) }
        };
    }
    return (
        <div>
            <div className="imageContainerDiv">
                {!isUploadDisabled ?
                    <div className="imageContainer">
                        <img alt="Mobile Image"
                            src={defaultImage}
                            width='68' height='48'
                        />
                    </div> :
                    <img alt="Mobile Image" src={props.src} id={props.output} className="uploadimageContainer" />
                }
            </div>
            <div className="imagebottomTextContainer" style={{ display: uploadDelete ? "none" : null }}>
                <input id={props.idupload} className="fileInput" type="file" required disabled={isUploadDisabled} />
                <a style={{ color: isUploadDisabled ? "#C4C4C4" : "#428BCA", width: "43%", cursor: "pointer" }} id="upload_link" class="pl-2" onClick={anchorClick}>
                    <small className="uploadText">Upload</small>
                    <img src={isUploadDisabled ? uploadDisable : upload} id="uuploadicon" alt="" width="15" height="15" loading="lazy" />
                </a>
                <a style={{ color: isDeleteDisabled ? "#C4C4C4" : "#428BCA", width: '40%', cursor: "pointer" }} class="pl-2" onClick={() => {
                    document.querySelector('#' + props.idupload).value = null;
                    setIsUploadDisabled(false);
                    setIsDeleteDisabled(true);
                    console.log('close requested')
                    props.handleRemove()
                }}><small className="deleteText">Delete</small>
                    <img alt="" src={isDeleteDisabled ? deleteDisable : deleteEnable} loading="lazy" className="uploadDeleteIcon" />
                </a>
            </div>
        </div>
    );
}
export default Upload;